<template>
    <div class="flex justify-between">
        <div class="flex items-center">
            <h4 class="mr0">{{ localizer.Localize("LandscapeManagement_Selection") }}</h4>
            <span class="calm-badge">{{ selectedFiles?.length }}</span>
        </div>
        <div class="calm-remove-all">
            <f-button
                type="ghost"
                :disabled="selectedFiles?.length === 0"
                class="flex items-center"
                @click="toggleFsoChild(false, root)"
            >
                <f-icon icon="delete" :disabled="true" class="theme-svg" />
                <span>{{ localizer.Localize("LandscapeManagement_Remove") }}</span>
            </f-button>
        </div>
    </div>
    <AlmFileSelectionSection :selectedFiles="selectedFiles" :isReadonly="false" @removeItem="toggleFsoChild" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import { Localizer } from "@/api/Localizer";
import { IAlmFileSystemObjectContent } from "@/components/pages/landscape/LandscapeManagementInterfaces";
import FileSystemObjectIcon from "@/components/helpers/FileSystemObjectIcon.vue";
import AlmFileSelectionSection from "@/components/pages/landscape/AlmFileSelectionSection.vue";

export default defineComponent({
    components: {
        FileSystemObjectIcon,
        AlmFileSelectionSection
    },
    data() {
        return {
            localizer: new Localizer(this.$store),
            isExpanded: true,
        };
    },
    computed: {
        ...mapGetters("explorer", ["root"]),
        ...mapGetters("alm", ["selectedFiles"]),
    },
    methods: {
        toggleExpandeCollapse() {
            this.isExpanded = !this.isExpanded;
        },
        getPath(fsoChild: IAlmFileSystemObjectContent): string {
            const arr: Array<string> | undefined = fsoChild?.fullPath?.split("/").filter((fileName: string) => {
                return !!fileName;
            });
            return arr?.join(" > ") || "";
        },
        toggleFsoChild($event: boolean, Fso: IAlmFileSystemObjectContent) {
            this.$emit('toggleFsoChild', $event, Fso)
        }
    },
    emits: ['toggleFsoChild'],
});
</script>

<style scoped>
.calm-remove-all > .button {
    display: flex;
    align-items: center;
}

.calm-remove-all {
    border-left: solid 1px var(--thin-border);
}

.calm-remove-all span {
    font-size: 14px;
    font-weight: 600;
    color: var(--foreground-primary);
}

.mr0 {
    margin-bottom: 0;
}

.calm-badge {
    display: inline-flex;
    height: 16px;
    gap: 2px;
    border-radius: 4px;
    padding: 4px 6px;
    background-color: var(--background-primary);
    border: solid 1px var(--accent-color5);
    font-weight: 600;
    font-size: 9px;
    line-height: 7px;
    color: var(--accent-color5);
    margin-left: 8px;
    margin-right: 8px;
}
</style>
